import styled from "styled-components";

export const EventBoxSection = styled.div`
  background-color: transparent;
  border-radius: 10px;
  cursor: pointer;
  color: #000;
`;
